// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import './assets/styles/common.scss'

import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)

import './permission'
import { formatDate } from "@/utils/common"
import plugins from './plugins'
import md5 from 'js-md5';
Vue.prototype.$md5 = md5;
Vue.config.productionTip = false

//全局挂载方法
Vue.prototype.formatDate = formatDate

Vue.use(plugins)

Vue.use(ElementUI)

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})


